// extracted by mini-css-extract-plugin
export default {"avatar":"UserThumbnail_avatar__cBDyk","thumbnail":"UserThumbnail_thumbnail__PiTud"};